module.exports = __webpack_public_path__ + "img/icon_kehudaoru_dingdan.c8d0a2cb.png";